import { Component, Event, EventEmitter, Listen, Prop, State, h } from '@stencil/core';
import { Address } from '../../../components';
import { Customer } from '../../../globals/customer';
import { objectHasValues, ErrorHelper } from '../../../helpers';
import { updateLeaseApplication } from '../../../utils';
import { AddressInfoTranslation } from '../../../globals/translations';

@Component({
  tag: 'address-info-state',
  styleUrl: './state-styles/address-info-state.scss',
  shadow: false,
})
export class AddressInfoState {
  @State() isLoading = false;
  @State() prohibitedStates: string[];

  @Prop({ mutable: true }) addressInfo: Customer['address'];
  @Prop({ mutable: true }) errors: ErrorHelper;
  @Prop() statesProhibited: string[];
  @Prop() translation: Partial<AddressInfoTranslation>;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() continueClick: EventEmitter;

  @Listen('updateAddressInfo', { target: 'body' })
  async getUpdatedAddress(event: CustomEvent) {
    if (event.detail) {
      const { streetAddress1, streetAddress2, city, state, zipCode } = event.detail;
      const { shipping } = this.addressInfo;
      const addressFields = {
        line1: shipping?.line1 || '',
        line2: shipping?.line2 || '',
        city: shipping?.city || '',
        zip: shipping?.zip || '',
        state: shipping?.state || '',
      } as Address;

      if (streetAddress1 !== shipping?.line1) {
        addressFields.line1 = streetAddress1;
      }

      if (streetAddress2 !== shipping?.line2) {
        addressFields.line2 = streetAddress2;
      }

      if (city !== shipping?.city) {
        addressFields.city = city;
      }

      if (state !== shipping?.state) {
        addressFields.state = state.toUpperCase();
      }

      if (zipCode !== shipping?.zip) {
        addressFields.zip = zipCode;
      }

      if (objectHasValues({ ...addressFields, line2: true })) {
        const address = { shipping: addressFields, billing: addressFields };

        try {
          this.isLoading = true;
          await updateLeaseApplication({ address });
          this.updateCustomer.emit({ address });
          this.continueClick.emit();
        } catch (error) {
          this.errors.hasGenericError = true;
        }
        this.isLoading = false;
      }
    }
  }

  render() {
    return (
      <pc-address-info {...this.addressInfo.shipping} isLoading={this.isLoading} prohibitedStates={this.statesProhibited} translation={this.translation}>
        {this.errors.hasGenericError && <pc-generic-error slot="error-card" />}
      </pc-address-info>
    );
  }
}
